import React from 'react';

export default function StepItem({ number, action, expected, last, darkMode }) {
  return (
    <div className="flex gap-6">
      <div className="flex flex-col items-center">
        <div className="w-8 h-8 rounded-full bg-indigo-500/20 border border-indigo-500/40 flex items-center justify-center text-indigo-400 text-xs font-bold">
          {number}
        </div>
        {!last && <div className="w-px h-full bg-gray-800 my-1" />}
      </div>
      <div className="pb-8">
        <p className="text-xs text-gray-500 uppercase font-bold mb-1 tracking-wider">Action</p>
        <p className="text-sm font-bold text-gray-200 mb-3">{action}</p>
        {/* <p className="text-xs text-gray-500 uppercase font-bold mb-1 tracking-wider">Expected Result</p>
        <p className="text-sm text-gray-400">{expected}</p> */}
      </div>
    </div>
  );
}
